// Get all regions
export const GET_MENU_ITEMS_REQUEST = "GET_MENU_ITEMS_REQUEST";
export const GET_MENU_ITEMS_SUCCESS = "GET_MENU_ITEMS_SUCCESS";
export const GET_MENU_ITEMS_FAILURE = "GET_MENU_ITEMS_FAILURE";

export const GET_EXPORT_ITEMS_REQUEST = "GET_EXPORT_ITEMS_REQUEST";
export const GET_EXPORT_ITEMS_SUCCESS = "GET_EXPORT_ITEMS_SUCCESS";
export const GET_EXPORT_ITEMS_FAILURE = "GET_EXPORT_ITEMS_FAILURE";

export const ADD_EXPORT_ITEMS_REQUEST = "ADD_EXPORT_ITEMS_REQUEST";
export const ADD_EXPORT_ITEMS_SUCCESS = "ADD_EXPORT_ITEMS_SUCCESS";
export const ADD_EXPORT_ITEMS_FAILURE = "ADD_EXPORT_ITEMS_FAILURE";

export const GET_PROJECT_MENU_ITEMS_REQUEST = "GET_PROJECT_MENU_ITEMS_REQUEST";
export const GET_PROJECT_MENU_ITEMS_SUCCESS = "GET_PROJECT_MENU_ITEMS_SUCCESS";
export const GET_PROJECT_MENU_ITEMS_FAILURE = "GET_PROJECT_MENU_ITEMS_FAILURE";

export const SEARCH_MENU_ITEMS_REQUEST = "SEARCH_MENU_ITEMS_REQUEST";
export const SEARCH_MENU_ITEMS_SUCCESS = "SEARCH_MENU_ITEMS_SUCCESS";
export const SEARCH_MENU_ITEMS_FAILURE = "SEARCH_MENU_ITEMS_FAILURE";

// Set form dirty (for detect unsaved changes)
export const SET_FORM_DIRTY_SUCCESS = "SET_FORM_DIRTY_SUCCESS";
export const SET_FORM_DIRTY_FAILURE = "SET_FORM_DIRTY_FAILURE";

export const GET_MENU_LINK_EMAIL_REQUEST = "GET_MENU_LINK_EMAIL_REQUEST";
export const GET_MENU_LINK_EMAIL_SUCCESS = "GET_MENU_LINK_EMAIL_SUCCESS";
export const GET_MENU_LINK_EMAIL_FAILURE = "GET_MENU_LINK_EMAIL_FAILURE";

export const CHANGE_CURRENCY = "CHANGE_CURRENCY";

export const SET_PENDING_ACTION = "SET_PENDING_ACTION";
export const SHOW_UNSAVED_PROMPT = "SHOW_UNSAVED_PROMPT";

export const TRIGGER_FCA_NOTICE_PROMPT = "TRIGGER_FCA_NOTICE_PROMPT";
export const SET_PENDING_CANCEL_ACTION = "SET_PENDING_CANCEL_ACTION";

export const entities = {
    RECOMMENDATIONS: "RECOMMENDATIONS",
    NARRATIVES: "NARRATIVES",
    ASSET_MANAGEMENT: "ASSET_MANAGEMENT",
    SMART_CHARTS: "SMART_CHARTS",
    SITES: "SITES",
    BUILDINGS: "BUILDINGS",
    BUILDING_VIEW: "BUILDING_VIEW",
    ASSET_VIEW: "ASSET_VIEW",
    REGIONS: "REGIONS",
    CAPITAL_REQUESTS: "CAPITAL_REQUESTS",
    SMART_CHARTS_IMAGE: "SMART_CHARTS_IMAGE"
};

export const entityName = {
    RECOMMENDATIONS: "Recommendation",
    NARRATIVES: "Narrative",
    ASSET_MANAGEMENT: "Asset",
    SMART_CHARTS: "Smart chart",
    SITES: "Site",
    BUILDINGS: "Building",
    REGIONS: "Region",
    CAPITAL_REQUESTS: "Capital Request"
};

export const LOCK_STATUS = {
    LOCKED: "locked",
    NOT_LOCKED: "not_locked",
    PARTIALLY_LOCKED: "partially_locked"
};

export const FILE_TYPE = {
    WORD: "word",
    PDF: "pdf",
    PPT: "ppt",
    EXCEL: "excel"
};

export const DYNAMIC_FIELD_TYPES = {
    TEXT: "text",
    MEMO: "memo",
    SELECT: "select",
    NUMBER: "number",
    DATE: "date",
    DATE_TIME: "date_time",
    CURRENCY: "currency",
    BOOLEAN: "boolean",
    COLOR: "color"
};

export const DYNAMIC_FIELD_MODES = {
    INPUT: "input",
    CALCULATED: "calculated",
    WEIGHTED_SELECTION: "weighted_selection",
    CLIENT_HIERARCHY: "client_hierarchy"
};

export const DYNAMIC_FIELD_MODE_LABELS = {
    [DYNAMIC_FIELD_MODES.INPUT]: "Input",
    [DYNAMIC_FIELD_MODES.CALCULATED]: "Calculated",
    [DYNAMIC_FIELD_MODES.WEIGHTED_SELECTION]: "Weighted Selection",
    [DYNAMIC_FIELD_MODES.CLIENT_HIERARCHY]: "Client Hierarchy"
};

export const STATIC_LINKABLE_FIELDS = {
    SUB_SYSTEM: { id: "sub_system_id", name: "Sub System", entity: "sub_system" }
};

export const RECOMMENDATION_SOURCE_TYPES = {
    REGULAR: "Regular",
    SIMILAR: "Similar",
    FULL_DUPLICATE: "Duplicate - Full",
    DUPLICATE_NO_CSP: "Duplicate - No CSP",
    GEO_HIERARCHY: "Building",
    CAPITAL_REQUEST: "Capital Request"
};

export const RECOMMENDATION_CREATION_METHODS = {
    [RECOMMENDATION_SOURCE_TYPES.SIMILAR]: "similar",
    [RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE]: "duplicate_full",
    [RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP]: "duplicate_no_csp",
    [RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY]: "same_geo_hierarchy"
};

export const DYNAMIC_FIELD_LABEL = {
    text: "Text",
    memo: "Memo",
    select: "Select",
    number: "Number",
    date: "Date",
    currency: "Currency",
    boolean: "Boolean",
    custom_select: "Select"
};

export const RECOMMENDATION_TYPES = {
    ASSET: "asset",
    SYSTEM: "system"
};

export const VIEW_ONLY_QUERY_PARAM = "viewOnly";

export const isViewOnlyEntity = search => new URLSearchParams(search || "").get(VIEW_ONLY_QUERY_PARAM) === "true";
